export const contentTableConfig = {
  title: '客户列表',
  propList: [
    {
      prop: 'nickName',
      label: '客户',
      minWidth: '120',
      slotName: 'consumer',
      align: 'left'
    },
    {
      prop: 'lectureNum',
      label: '听课次数',
      sortable: true,
      minWidth: '80',
      slotName: 'lecture'
    },
    {
      prop: 'callNum',
      label: '通话次数(≥10min)',
      sortable: true,
      minWidth: '80',
      slotName: 'call'
    },
    { prop: 'belongDeptName', label: '所属部门', minWidth: '80' },
    { prop: 'belongEmpName', label: '所属员工', minWidth: '80' },
    {
      prop: 'duration',
      label: '总访问时长(min)',
      sortable: true,
      minWidth: '120',
      slotName: 'duration'
    },
    {
      prop: 'yesterday',
      label: '昨日是否通话',
      minWidth: '60'
    }
  ]
}
